import {MemberPost} from "../member-post/member-post";
export class PageSlider {
  images: string[] = [];
  imagesByMobile: string[] = [];
}

export class PageMemberPost {
  teams: number[] = [];
  individuals: number[] = [];
}

export class PageHomeMemberPost {
  teams: MemberPost[] = [];
  individuals: MemberPost[] = [];
}

export class PageStory {
  backgroundMobile: string;
  background: string;
  content: string;
  team: string;
  name: string;
  logo: string;
  thumbnail: string;
  title: string;
}

export class Instagram {
  link: string;
  image: string;
}

export class PageInstagram {
  link: string;
  image: string;
}

export class PageAdminInfo {
  name: string;
  work: string;
  intro: string;
  photo: string;
  category: string = 'manager';
}

export class PageGuide {
  title: string;
  content: string;
  order: number;
  depth: number;
  type: string;
  titleBold: boolean;
  link?: string;
}






export class PageMypageLink {
  icon: string;
  title: string;
  url: string;
}




export class PageCampusKeyword {
  keywords: string[] = [];
  subjects: string[] = [];
}


// ___________________________________________

export class PageSlider2 {
  sliders: PageSlider2Item[] = [];
}

export class PageSlider2Item {
  image: string;
  mobileImage: string;
  tag: string;
  title: string;
  subTitle: string;
  linkName: string;
  url: string;
  newWindow: boolean;
  startTime: string;
  endTime: string;
}

export class PartnerCategory {
  id: Number;
  name: string;
  detail: string;
}

export class PartnerItem {
  image: string;
  title: string;
  description: string;
  link: string;
}

export class PagePartnerView {
  id: Number;
  title: string;
  detail: string;
  partners: PartnerItem[] = [];
}

export class PageSpaceBanner {
  banners: PageSpaceBannerItem[] = [];
}
export class PageSpaceBannerItem {
  image: string;
  mobileImage: string;
  title: string;
  description: string;
}

export class PageSpaceFloorInfo {
  floorGuides: PageSpaceFloorItem[] = [];
}
export class PageSpaceFloorItem {
  title: string;
  description: string;
  linkName: string;
  url: string;
  newWindow: string;
  images: PageSpaceFloorItemImg[];
}
class PageSpaceFloorItemImg {
  image: string;
  mobileImage: string;
  title: string;
}


export class FaqCategory {
  id: string;
  name: string;
}

export class FaqItem {
  title: string;
  answer: string;
  category: { id: number; }
}

export class PageFaq {
  id: string;
  category: string;
  faqs: FaqItem[];
}

class PlanMeta {
  furniture: string;
  deposit: string;
  term: string;
  fee: string;
  discountBasis: string;
}

class ImageItem {
  image: string;
  mobileImage: string;
}

export class PlanItem {
  title: string;
  subTitle: string;
  content: string;
  url: string;
  meta: PlanMeta;
  images: ImageItem[];
}

export class PagePlan {
  plans: PlanItem[]
}


// 2020.11월 21일 리뉴얼 요구 사항
export namespace SliderV2 {
  export interface Res {
    sliders: Slide[]
  }
  export interface Slide {
    title: string;
    detail: string;
    image : string;
    mobileImage: string;

    buttonName: string;
    buttonUrl: string;
    newWindow: boolean;
    buttonVisible: boolean;
  
    startTime: string;
    endTime: string;
  }
}
export namespace HomeSection {
  export interface Res {
    sections: Section[]
  }
  export interface Section {
    title: string;
    tag: string;
    detail: string;
    image: string;
    mobileImage: string;
    visible: boolean;
    buttonName: string;
    buttonUrl: string;
    newWindow: boolean;
    buttonVisible: boolean;
  }
}

export namespace About {
  export interface Res {
    detail: string;
    image: string;
    mobileImage: string;
    sliders: Slide[];
    section1: {
      title: string;
      detail1: string;
      detail2: string;
    };
    section2: {
      title: string;
      details: string[];
    };
    section3: {
      title: string;
      details: {
        title: string; 
        detail: string[];
      }[];
    };
  }

  export interface Slide { 
    image: string;
    mobileImage: string;
  }
}


// WEBPACK FOOTER //
// ./src/app/service/page/page.ts